import React, { useState } from 'react';
import './PartnerLogin.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from 'react-router-dom';

const PartnerLogin = () => {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    partnerId: '',
    phone: '',
    otp: '',
    savePassword: false,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

const validateStep1 = () => {
    const newErrors = {};

    if (!form.partnerId.trim() && !form.phone.trim()) {
      newErrors.partnerId = 'Enter Partner ID or Phone Number';
      newErrors.phone = 'Enter Partner ID or Phone Number';
    }

    if (form.phone.trim() && !/^\d{10}$/.test(form.phone)) {
      newErrors.phone = 'Phone must be 10 digits';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateOTP = () => {
    const newErrors = {};
    if (!/^\d{4,6}$/.test(form.otp)) newErrors.otp = 'Enter a valid OTP';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleStep1Submit = async (e) => {
    e.preventDefault();
    if (!validateStep1()) return;
    setLoading(true);

    try {
      const res = await fetch('https://abomed-backend-nodejs.vercel.app/partner/signin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          partner_id: Number(form.partnerId),
          phone_number: Number(form.phone),
        }),
      });
      const data = await res.json();
      console.log(data)
      if (res.ok) {
        toast.success(data.message || 'OTP sent to your phone number.');
        setStep(2);
      } else {
        toast.error(data.message || 'Failed to send OTP.');
      }
    } catch (err) {
      toast.error('Network error. Please try again.');
    }
    setLoading(false);
  };

  const handleOTPSubmit = async (e) => {
    e.preventDefault();
    if (!validateOTP()) return;
    setLoading(true);

    try {
      const res = await fetch('https://abomed-backend-nodejs.vercel.app/partner/verify-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          partner_id: Number(form.partnerId),
          phone_number: form.phone,
          otp: form.otp,
        }),
      });
      const data = await res.json();
      console.log(data)
      if (res.ok && data.token) {
        localStorage.setItem('partner_token', data.token);
        toast.success(data.message || 'Login successful!');
        setTimeout(() => navigate('/partner'), 800);
      } else {
        setErrors({ otp: 'Invalid OTP. Try again.' });
        toast.error(data.message || 'Invalid OTP. Please try again.');
      }
    } catch (err) {
      toast.error('Network error. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="partner-login-wrapper">
      <ToastContainer />
      <div className="partner-login-card">
        <h2 className="login-title">Marketing Partner Login</h2>
        <form onSubmit={step === 1 ? handleStep1Submit : handleOTPSubmit}>
          {step === 1 && (
            <>
              <div className="form-group">
                <label>Partner ID</label>
                <input
                  type="text"
                  name="partnerId"
                  value={form.partnerId}
                  onChange={handleChange}
                  placeholder="Enter your Partner ID"
                />
                {errors.partnerId && <span className="error">{errors.partnerId}</span>}
              </div>

              <div className="or-divider">OR</div>

              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  placeholder="Enter your 10-digit phone number"
                />
                {errors.phone && <span className="error">{errors.phone}</span>}
              </div>

              <div className="checkbox-group row">
                <input
                  type="checkbox"
                  name="savePassword"
                  checked={form.savePassword}
                  onChange={handleChange}
                  id="remember"
                />
                <label htmlFor="remember">Remember Me</label>
              </div>
            </>
          )}

          {step === 2 && (
            <div className="form-group">
              <label>Enter OTP</label>
              <input
                type="text"
                name="otp"
                value={form.otp}
                onChange={handleChange}
                placeholder="Enter OTP"
              />
              {errors.otp && <span className="error">{errors.otp}</span>}
            </div>
          )}

          <button type="submit" disabled={loading}>
            {loading ? 'Submitting...' : step === 1 ? 'Send OTP' : 'Verify & Login'}
          </button>

          <div className="register-link">
            Not registered?{' '}
            <Link to="/partner/register" className="link">
              Register here
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PartnerLogin;
